/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SetTilePatternResponse
 */
export interface SetTilePatternResponse {
    /**
     * 
     * @type {boolean}
     * @memberof SetTilePatternResponse
     */
    success: boolean;
    /**
     * 
     * @type {string}
     * @memberof SetTilePatternResponse
     */
    configString?: string | null;
}

export function SetTilePatternResponseFromJSON(json: any): SetTilePatternResponse {
    return SetTilePatternResponseFromJSONTyped(json, false);
}

export function SetTilePatternResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SetTilePatternResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'success': json['success'],
        'configString': !exists(json, 'configString') ? undefined : json['configString'],
    };
}

export function SetTilePatternResponseToJSON(value?: SetTilePatternResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'success': value.success,
        'configString': value.configString,
    };
}


